import React from 'react';

const LinkedinIcon = (): JSX.Element => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.1567,22.158h-3.8514v-6.0374c0-1.4378-.0243-3.2902-2.0071-3.2902-2.0071,0-2.3155,1.5683-2.3155,3.185v6.1345h-3.8514v-12.3984h3.6967v1.6977h.0485c.7553-1.2922,2.1527-2.0556,3.6481-2.0071,3.908,0,4.6229,2.5672,4.6229,5.907l.0081,6.8089h.001ZM5.7846,8.0518c-1.2346,0-2.2346-.999-2.2346-2.2346s.999-2.2346,2.2346-2.2346,2.2346.999,2.2346,2.2346-.999,2.2346-2.2346,2.2346ZM7.7098,22.158h-3.8595v-12.4075h3.8595v12.4075ZM24.0738.0002H1.9171C.8686-.0079.0162.8293,0,1.8769v22.2467c.0162,1.0485.8696,1.8847,1.9171,1.8766h22.1567c1.0485.0162,1.909-.8291,1.9252-1.8766V1.8769C25.9828.8283,25.1213-.0159,24.0738.0002Z" />
  </svg>
);

export default LinkedinIcon;
